import React, { useMemo } from 'react';
import { World } from '@saleshandy/icons';
import TruncatedTextWithAutoTooltip from '../../../../../shared/components/truncated-text-with-auto-tooltip';
import { Placement } from '../../../../../shared/design-system/components/overlay';

interface TextCellProps {
  value: string | number | null | undefined;
  prefix?: string;
  redirectUrl?: string;
}

const TextCell: React.FC<TextCellProps> = ({ value, prefix, redirectUrl }) => {
  const displayValue = useMemo(() => {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const baseValue = typeof value === 'number' ? value.toString() : value;
    return prefix ? `${prefix}${baseValue}` : baseValue;
  }, [value, prefix]);

  if (displayValue === null) {
    return <div className="v2-lead-text-cell">-</div>;
  }

  if (redirectUrl) {
    const lowerCaseUrl = redirectUrl.toLowerCase();
    const hasProtocol =
      lowerCaseUrl.startsWith('http://') || lowerCaseUrl.startsWith('https://');
    
    let href: string;
    if (hasProtocol) {
      // Normalize protocol to lowercase, preserve rest of URL case
      href = redirectUrl.replace(/^https?:\/\//i, (match) => match.toLowerCase());
    } else {
      // Add https:// and preserve the original case
      href = `https://${redirectUrl}`;
    }

    return (
      <div className="v2-lead-text-cell v2-lead-link-cell">
        <a href={href} target="_blank" rel="noreferrer">
          <span>
            <World />
          </span>
          <TruncatedTextWithAutoTooltip
            text={displayValue}
            placement={Placement.Auto}
          />
        </a>
      </div>
    );
  }

  return (
    <div className="v2-lead-text-cell">
      <TruncatedTextWithAutoTooltip
        text={displayValue}
        placement={Placement.Auto}
      />
    </div>
  );
};

// Memoize TextCell to prevent unnecessary re-renders
export default React.memo(
  TextCell,
  (prevProps, nextProps) =>
    prevProps.value === nextProps.value &&
    prevProps.prefix === nextProps.prefix &&
    prevProps.redirectUrl === nextProps.redirectUrl,
);
